export const RECORD_PERCIEVED_TIME_EVENTS = {
    TABLE_BOOKING_APP_LOAD_TIME: "blaze_dineout_checkout_cart_load_time",
    BILL_PAYMENT_APP_LOAD_TIME: "blaze_bill_payment_checkout_app_load_time",
    STEAL_STORE_APP_LOAD_TIME: "blaze_steal_store_checkout_app_load_time",
};
